import { Component, ViewChild, Input, Output, EventEmitter, OnChanges, AfterViewInit, SimpleChanges } from '@angular/core'
import { Cookie } from 'ng2-cookies/ng2-cookies'
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal'
import { DialogConfiguration } from './'

@Component({
  selector: 'mp-dialog',
  templateUrl: './dialog.html',
  styleUrls: ['./dialog.scss'],
})
export class DialogComponent implements OnChanges, AfterViewInit {
  public buttons
  public dismissable
  public dismissButtonTitle
  public size
  public cssClass

  @Input() public title: string
  @Input() public message: string

  // TODO [GitHub Issue]: Should this be deprecated the use of #open() and #close() be enforced?
  @Input() public show: boolean

  @Input() public icon: string

  @Output() public onOpen: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Output() public onClose: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Output() public onDismiss: EventEmitter<boolean> = new EventEmitter<boolean>()

  @ViewChild('modalViewChild')
  public set modal(value: ModalComponent) {
    this._modal = value
  }

  private _modal: ModalComponent

  constructor() {
    this.show = false
    this.dismissable = true
    this.dismissButtonTitle = 'Cancel'
    this.size = 'md'
    this.cssClass = ''
  }

  public configure(configurationObject: DialogConfiguration) {
    [
      'title',
      'message',
      'dismissable',
      'dismissButtonTitle',
      'size',
      'cssClass',
    ].forEach((propertyName) => {
      if (typeof configurationObject[propertyName] !== 'undefined') {
        this[propertyName] = configurationObject[propertyName]
      }
    })
    this.buttons = []
    configurationObject.buttons.forEach((button) => {
      button.cssClasses = button.cssClasses || []
      this.buttons.push(button)
    })
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (Array.isArray(this.buttons) && (! this.buttons.length && ! this.dismissable)) {
      throw new Error('At least one button must be shown')
    }

    if (changes.show) {
      if (this.show) {
         this.open()
      } else {
        this.close()
      }
    }
  }

  public ngAfterViewInit() {
    this._modal.onOpen.subscribe((e) => this.onOpen.emit(e))
    this._modal.onClose.subscribe((e) => this.onClose.emit(e))
    this._modal.onDismiss.subscribe((e) => this.onDismiss.emit(e))
  }

  public open() {
    this.show = true
    this._modal.open(this.size)
  }

  public close() {
    this._modal.close()
    this.show = false
  }

  public dismiss() {
    this._modal.dismiss()
  }

  public isOpen(): boolean {
    return this.show
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/dialog/dialog.component.ts